let state = {
	animationInProgress: false,
	animationStartTime: null,
	animationEndTime: null,
	lastScrollPosition: 0,
	lastElementScrolled: -1,
	visibleElementIndex: -1,
	clear: false,
};

export function getState(key) {
	return state[key];
}

export async function setState(key, value) {
	state[key] = value;
}

